import { DermloopRelation } from '@dermloop/shared/util-relation-types';
import { Transform, Type } from 'class-transformer';
import { IsArray, IsOptional, isString } from 'class-validator';

/**
 * Used to validate query parameters from rtk request.
 * Can easily be extended with other queries.
 * RTK query param concats an array of strings to a comma separated string, and we transform it back to an array.
 * */
export class QueryParams<T> {
  @IsArray()
  @IsOptional()
  @Type(() => String)
  @Transform(({ value }: { value: string }) =>
    isString(value) ? value.split(',') : [],
  )
  relations?: DermloopRelation<T>[];
}
